/**
 * DOCUMENT-ACTIONS-MODAL
 * Select an action for a generated document
 */
import CardButton from "@/components/card-button"
import CardContainer from "@/components/card-container"
import Modal from "@/components/modal"
import { Document } from "../../model/document.types"
import { faDownload, faArrowUpRightFromSquare, faLink, faPen } from "@fortawesome/free-solid-svg-icons"
import { canOpenDocument } from "../../utils/document-file.utils"
import { getDocumentYear } from "../../utils/document-year.utils"

interface Props {
  document: Document
  onClose: () => void
  onDelete: () => void
  onDownload: () => void
  onOpen?: () => void
  onShare: () => void
  onEdit: () => void
}

function formatDocumentDate(date: Date | string) {
  return new Date(date).toLocaleDateString("fr-FR", {
    month: "long",
    year: "numeric"
  })
}

//PAPRIPACT : program year, DUERP : creation month
function getDocumentTitle(document: Document) {
  return document.type === "duerp"
    ? `Document unique ${formatDocumentDate(document.date)}`
    : `PAPRIPACT ${getDocumentYear(document)}`
}

export default function DocumentActionsModal(props: Props) {
  const canOpen = canOpenDocument(props.document)
  return (
    <Modal
      title={getDocumentTitle(props.document)}
      isCloseButtonVisible
      onDelete={() => props.onDelete()}
      onClose={props.onClose}>
      {/* Fixed width: 2 cards per row */}
      <div className="mx-auto w-[400px]">
        <CardContainer>
          {canOpen && (
            <CardButton icon={faArrowUpRightFromSquare} title="Ouvrir" isCta onClick={() => props.onOpen?.()} />
          )}
          <CardButton icon={faDownload} title="Télécharger" isCta={!canOpen} onClick={() => props.onDownload()} />
          <CardButton icon={faLink} title="Partager le lien" onClick={() => props.onShare()} />
          <CardButton icon={faPen} title="Modifier" onClick={props.onEdit} />
        </CardContainer>
      </div>
    </Modal>
  )
}
